import { defineComponent as _defineComponent } from 'vue'
import { IMessageModel } from '@tencentcloud/chat-uikit-engine';
import TUICustomerServicePlugin from '@tencentcloud/tui-customer-service-plugin/index.vue';
interface IProps {
  message: IMessageModel;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-customer-service',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { message: IMessageModel }



return { __sfc: true,props, TUICustomerServicePlugin }
}

})